import request from "../request"
export function getPersonRedYellowList(data) {
    return request({
      url: '/personRedYellow/',
      method:'get',
      params:data
    })
  }

  export function getPersonRedYellow(id) {
    return request({
      url: '/personRedYellow/id',
      method:'get',
    //   params:data
    })
  }


// WEBPACK FOOTER //
// ./src/api/personRedYellow.js